export default __webpack_public_path__ + "static/media/onboardingAsideMb.662aa5f4.png";